import activeTabs from '../../../../../../javascript/modules/Gull/Framework/activeTabs.js';

import stap1 from './aanvraagIndienen/stap1.js';
import stap2 from './aanvraagIndienen/stap2.js';
import stap3 from './aanvraagIndienen/stap3.js';
import stap4 from './aanvraagIndienen/stap4.js';
import stap5 from './aanvraagIndienen/stap5.js';

const aanvraagIndienen = {
	init() {
		activeTabs.initTab([stap1, stap2, stap3, stap4, stap5]);
	},
};

export default aanvraagIndienen;
